import React from "react";

type ButtonWidgetProps = {
    inputType?: string,
    isEnabled?: boolean,
    errorMessage?: string,
    placeholder?: string,
    maxLength?: number,
    class?: string,
    action?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default class InputFieldCreatorRegistrationWidget extends React.Component<ButtonWidgetProps, {}> {
    render() {
        const isDisable = this.props.isEnabled === false;
        return (
            <>
                <input 
                    disabled={isDisable}
                    className={this.props.class}
                    type={this.props.inputType} 
                    maxLength={this.props.maxLength}
                    onChange={isDisable ? undefined : this.props.action} 
                    placeholder={this.props.placeholder}
                >
                </input>
                <div className="divError">
                    {
                    this.props.errorMessage !== "" && this.props.errorMessage !== null &&
                        <span className="errormsg"><img alt="ic-wrong" width="10" src={global.ImgUrl+'shopable/ic-wrong@3x.png'}></img> &nbsp;&nbsp; {this.props.errorMessage}</span>
                    }
                </div>
            </>
        );
    }
}